<template>
  <div class="section">

    <b-table
      :data="isEmpty ? [] : $store.state.connections"
      :narrowed="false"
      :hoverable="true"
      :selected.sync="selected"
      :paginated="true"
      :per-page="20"
      @select="setActiveRow"
    >

      <template slot-scope="props">
        <b-table-column
          field="type"
          label="Type"
        >
          {{ props.row.type }}
        </b-table-column>

        <b-table-column
          field="name"
          label="Name"
        >
          {{ props.row.name }}
        </b-table-column>

        <b-table-column
          field="email"
          label="Email"
        >
          {{ props.row.email }}
        </b-table-column>

        <b-table-column
          field="phone"
          label="Phone"
          centered
        >
          {{ props.row.phone }}
        </b-table-column>

        <b-table-column
          field="visibility"
          label="Visibility"
          centered
        >
          {{ props.row.deleted | visibility }}
        </b-table-column>

        <b-table-column
          field="controls"
          label=""
          centered
        >

          <div class="columns">
            <div class="column">
              <b-tooltip label="Edit connection information">
                <a
                  class="fas fa-edit"
                  @click="edit()"
                ></a>
              </b-tooltip>
            </div>
            <div class="column">
              <b-tooltip
                label="Hide connection"
                v-if="!props.row.deleted"
              >
                <a
                  class="fas fa-eye-slash"
                  @click="hide(props.row)"
                ></a>
              </b-tooltip>
            </div>
            <div class="column">
              <b-tooltip
                label="Show connection"
                v-if="props.row.deleted"
              >
                <a
                  class="fas fa-eye"
                  @click="show(props.row)"
                ></a>
              </b-tooltip>
            </div>
          </div>

        </b-table-column>

      </template>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon
                icon="emoticon-happy"
                size="is-large"
              >
              </b-icon>
            </p>
            <p>No connections, yet. Add a new connection</p>
          </div>
        </section>
      </template>

    </b-table>

  </div>
</template>

<script>
export default {
  props: {
    open: false
  },

  data() {
    return {
      activeConnection: undefined,
      selected: undefined,
      isEmpty: undefined
    };
  },

  mounted() {
    console.log("mounted");
    var userId = this.$store.getters.session.user.id;
    var includeHidden = true;
    this.$store.dispatch("getUserConnections", {
      userId,
      includeHidden
    });
  },

  methods: {
    async edit() {
      console.log("edit()", this.$store.state.connectionEdit);
      this.$store.state.connectionEdit.mode = "edit";
      await this.$store.commit("SET_CONNECTION_EDIT_ISACTIVE", true);
    },

    show(connection) {
      console.log("show()");
      this.$buefy.dialog.confirm({
        title: "Show connection",
        message: `<b>Show this connection on properties?</b><br><br>${
          connection.type
        } - ${connection.name}`,
        confirmText: "Show Connection",
        type: "is-info",
        hasIcon: true,
        onConfirm: () => {
          console.log("onConfirm()", this.$store.getters.session.user.id);
          connection.deleted = false;
          var userId = this.$store.getters.session.user.id;
          this.$store.dispatch("updateUserConnection", {
            userId,
            connection
          });
          this.$buefy.toast.open({
            message: "Connection shown",
            type: "is-success",
            duration: 5000
          });
        }
      });
    },

    hide(connection) {
      console.log("hide()");
      this.$buefy.dialog.confirm({
        title: "Hide connection",
        message: `<b>Hide this connection on properties?</b><br><br>${
          connection.type
        } - ${connection.name}`,
        confirmText: "Hide Connection",
        type: "is-info",
        hasIcon: true,
        onConfirm: () => {
          console.log("onConfirm()", this.$store.getters.session.user.id);
          connection.deleted = true;
          var userId = this.$store.getters.session.user.id;
          this.$store.dispatch("updateUserConnection", {
            userId,
            connection
          });
          this.$buefy.toast.open({
            message: "Connection hidden",
            type: "is-success",
            duration: 5000
          });
        }
      });
    },

    setActiveRow(row) {
      console.log("setActiveRow", row);
      this.activeConnection = row;
      this.$store.state.connectionEdit.originalConnection = row;
      this.$store.state.connectionEdit.connection = row;
    }
  }
};
</script>

<style>
</style>
